module.exports = __webpack_public_path__ + "assets/img/tehui.80f54040.png";